'use strict';
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice from "./app.data.-General-Practice-User-Out-Of-Office.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_GeneralPracticeInvolvement$$anon$10() {
}
export { $c_Lapp_data_GeneralPracticeInvolvement$$anon$10 as $c_Lapp_data_GeneralPracticeInvolvement$$anon$10 };
$c_Lapp_data_GeneralPracticeInvolvement$$anon$10.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeInvolvement$$anon$10.prototype.constructor = $c_Lapp_data_GeneralPracticeInvolvement$$anon$10;
/** @constructor */
function $h_Lapp_data_GeneralPracticeInvolvement$$anon$10() {
}
export { $h_Lapp_data_GeneralPracticeInvolvement$$anon$10 as $h_Lapp_data_GeneralPracticeInvolvement$$anon$10 };
$h_Lapp_data_GeneralPracticeInvolvement$$anon$10.prototype = $c_Lapp_data_GeneralPracticeInvolvement$$anon$10.prototype;
$c_Lapp_data_GeneralPracticeInvolvement$$anon$10.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_GeneralPracticeInvolvement$$anon$10.prototype.apply__O = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().schemaForOption__Lsttp_tapir_Schema__Lsttp_tapir_Schema($j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice.$m_Lapp_data_GeneralPracticeUserOutOfOffice$().derived$Schema__Lsttp_tapir_Schema());
});
var $d_Lapp_data_GeneralPracticeInvolvement$$anon$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeInvolvement$$anon$10, "app.data.GeneralPracticeInvolvement$$anon$10", ({
  Lapp_data_GeneralPracticeInvolvement$$anon$10: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_GeneralPracticeInvolvement$$anon$10 as $d_Lapp_data_GeneralPracticeInvolvement$$anon$10 };
//# sourceMappingURL=app.data.-General-Practice-Involvement$$anon$10.js.map
